import {
    SAVE_TENANT_USER_ID,
  } from '../../Constants/Type';
  
  export const saveTenantUserId = text => ({
    type: SAVE_TENANT_USER_ID,
    payload: text
  });
  